import ja from './ja';
import en from './en';
import type { RelatedDictionary, RelatedSite } from './types';

export type { RelatedBlock, RelatedFaq, RelatedImage, RelatedSite, RelatedHub, RelatedCommon, RelatedDictionary } from './types';

/** 言語別辞書(ja / en)。他言語は ja へフォールバック。 */
export function getRelatedDictionary(lang: string): RelatedDictionary {
  return lang === 'en' ? en : ja;
}

export function getRelatedSite(lang: string, slug: string | undefined): RelatedSite | undefined {
  return getRelatedDictionary(lang).sites.find((s) => s.slug === slug);
}
